import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { remCal } from '../../utils/sass.utils'

const StyledHrefButtonGhost = styled.a`
  display: inline-block;

  padding: 1rem 1.25rem;
  background: transparent;
  border-radius: ${ remCal(3) };
  color: white;
  box-shadow: inset 0px 0px 0px 2px white;
  margin-bottom: 1rem;
  border: 1px solid white;
  &:hover {
    background: white;
    color: ${ ({ theme }) => theme.jewel };
    text-decoration: none;
    border: 1px solid white;
    cursor: pointer;
  }
`

const HrefButtonGhost = ({ children, href, target, inverse }) => {
  return (
    <StyledHrefButtonGhost inverse={inverse} href={href} target={target}>
      {children}
    </StyledHrefButtonGhost>
  )
}
HrefButtonGhost.defaultProps = {
  inverse: false,
}

HrefButtonGhost.propTypes = {
  children: PropTypes.node,
  inverse: PropTypes.bool,
}
export default HrefButtonGhost
